module.exports = __webpack_public_path__ + "img/gallery-birthday.73b43e29.png";